module.exports = __webpack_public_path__ + "img/home-page-bg.967c8447.png";